// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"228":"268147eb","292":"a5f01160","625":"230182b9","831":"43475b9e","918":"1f938d93"}[chunkId] + ".js";
};